import cameraElement from "../item/plan/camera.js";
import imageElement from "../item/plan/image.js";
import textElement from "../item/plan/text.js";
import videoElement from "../item/plan/video.js";
import alphaMattingElement from "../item/plan/filter/AlphaMatting.js";
import grayscaleElement from "../item/plan/filter/Grayscale.js";
import blurElement from "../item/plan/filter/Blur.js";
import equalizerElement from "../item/plan/filter/Equalizer.js";
import colorizeElement from "../item/plan/filter/Colorize.js";
import duotoneElement from "../item/plan/filter/Duotone.js";

export default [
    {
        name: "Camera",
        text: "Photo client",
        description: "photo client",
        type: "CameraPlanItem",
        iconSVG: "galleryIcon",
        subType: [
            { type: "^.*FilterItem$", property: "Filters", is: "array" },
        ],
        constructor: cameraElement,
    },
    {
        name: "Image",
        text: "Image",
        description: "image",
        type: "ImagePlanItem",
        iconSVG: "imageGalleryIcon",
        subType: [
            { type: "^.*FilterItem$", property: "Filters", is: "array" },
        ],
        constructor: imageElement,
    },
    {
        name: "Text",
        text: "Texte",
        description: "texte",
        type: "TextPlanItem",
        subType: [],
        iconSVG: "textIcon",
        constructor: textElement,
    },
    {
        name: "Video",
        text: "Video",
        description: "video",
        type: "VideoPlanItem",
        subType: [
            { type: "^.*FilterItem$", property: "Filters", is: "array" },
        ],
        iconSVG: "playIcon",
        constructor: videoElement,
    },
    {
        name: "AlphaMatting",
        text: "Alpha Matting",
        description: "Alpha Matting",
        type: "AlphaMattingFilterItem",
        iconSVG: "alphaMattingIcon",
        subType: [],
        constructor: alphaMattingElement,
    },
    {
        name: "Grayscale",
        text: "Grayscale",
        description: "Grayscale",
        type: "GrayscaleFilterItem",
        iconSVG: "grayscaleIcon",
        subType: [],
        constructor: grayscaleElement,
    },
    {
        name: "Blur",
        text: "Blur",
        description: "Blur",
        type: "BlurFilterItem",
        iconSVG: "blurIcon",
        subType: [],
        constructor: blurElement,
    },
    {
        name: "Equalizer",
        text: "Equalizer",
        description: "Equalizer",
        type: "EqualizerFilterItem",
        iconSVG: "equalizerIcon",
        subType: [],
        constructor: equalizerElement,
    },
    {
        name: "Colorize",
        text: "Colorize",
        description: "Colorize",
        type: "ColorizeFilterItem",
        iconSVG: "colorizeIcon",
        subType: [],
        constructor: colorizeElement,
    },
    {
        name: "Duotone",
        text: "Duotone",
        description: "Duotone",
        type: "DuotoneFilterItem",
        iconSVG: "duotoneIcon",
        subType: [],
        constructor: duotoneElement,
    },
];

